// @flow
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import {
  reducer as modalReducer,
  REDUCER_MOUNT_POINT as MODAL_MP,
} from '@team-griffin/redux-modal-router';
import dst from './dst';

export default combineReducers({
  form,
  dst,
  [MODAL_MP]: modalReducer,
});
